"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SemaphoreDemo__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ISemaphore",
                name: "_semaphore",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_groupId",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "groupId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "identityCommitment",
                type: "uint256",
            },
        ],
        name: "join",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "semaphore",
        outputs: [
            {
                internalType: "contract ISemaphore",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
class SemaphoreDemo__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(_semaphore, _groupId, overrides) {
        return super.deploy(_semaphore, _groupId, overrides || {});
    }
    getDeployTransaction(_semaphore, _groupId, overrides) {
        return super.getDeployTransaction(_semaphore, _groupId, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.SemaphoreDemo__factory = SemaphoreDemo__factory;
SemaphoreDemo__factory.bytecode = _bytecode;
SemaphoreDemo__factory.abi = _abi;
